import React from "react";

const FEATURES = [
  {
    icon: "📖",
    title: "Koranundervisning",
    text: "Tilby koranundervisning og kulturelle aktiviteter for barn og unge på alle nivåer.",
  },
  {
    icon: "🛡️",
    title: "Forebyggende arbeid",
    text: "Drive forebyggende arbeid mot rus, kriminalitet og ekstremisme gjennom Koranens verdier om fred, ansvar og lovlydighet.",
  },
  {
    icon: "🎓",
    title: "Kurs & Aktiviteter",
    text: "Arrangere kurs, fritidsaktiviteter og samfunnsnyttige arrangementer for lokalsamfunnet.",
  },
];

/**
 * About — organisation mission with feature cards.
 */
function About() {
  return (
    <section className="about-section py-5">
      <div className="container">
        <h2 className="text-center mb-2" style={{ color: "#d4af37" }}>
          🌙 Om Al-Yasin
        </h2>
        <p className="text-center text-muted mb-5">
          Vår visjon og hva vi jobber for i lokalsamfunnet
        </p>

        <div className="row g-4 justify-content-center">
          {FEATURES.map((f, i) => (
            <div key={i} className="col-md-6 col-lg-4">
              <div className="about-card shadow rounded-4 p-4 h-100 d-flex flex-column align-items-center text-center">
                <div className="about-icon mb-3">{f.icon}</div>
                <h5 className="fw-bold">{f.title}</h5>
                <p className="text-muted mb-0">{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
